import { Component } from '@angular/core';

import { NavigationService } from '@ib-core/services/navigation.service';
import { IB_ROUTES } from '@ib-enums/routes.enum';

@Component({
  selector: 'ib-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent {
  constructor(private navS: NavigationService) {}

  toHome(): void {
    this.navS.goToRoute(IB_ROUTES.BASE);
  }

  testError(): void {
    throw new Error('Sentry Test Error');
  }
}
